import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactTable from 'react-table';
import { Box, Button, Checkbox, Grid } from '@mui/material';

import { SELECTED_CATALOGS_OPTIONS } from '../../../modules/reports/reducer';
import './SessionResults.scss';

const CatalogsGroups = ({ data, style, index }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const selectedCatalogOptions = useSelector(state => state.reports.selectedCatalogOptions);
  const houseRef = useSelector(state => state.house.houseRef);

  const { groupName, catalogs = [] } = data[index];

  const catalogsData = catalogs.map(({ catalogRef, catalogCurrencyCode }) => ({
    catalogRef,
    catalogCurrencyCode
  }));

  const showResultsHandler = (catalogRef) => {
    dispatch({
      type: SELECTED_CATALOGS_OPTIONS,
      payload: {
        addItem: true,
        catalogsData
      }
    });

    history.push(`/reports/sessionResults/viewSessionResults/${houseRef}/${catalogRef}`);
  };

  const columns = [
    {
      Header:
        catalogs.length > 1 ? (
          <Checkbox
            size="small"
            className="sales-checkbox sales-header-checkbox"
            checked={catalogsData.every(({ catalogRef: ref }) => selectedCatalogOptions.some(({ catalogRef }) => ref === catalogRef))}
            onChange={e => {
              dispatch({
                type: SELECTED_CATALOGS_OPTIONS,
                payload: {
                  addItem: e.target.checked,
                  catalogsData
                }
              });
            }}
          />
        ) : (
          ''
        ),
      id: 'actions',
      accessor: '',
      minWidth: 20,
      sortable: false,
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      Cell: ({ original: { catalogRef, catalogCurrencyCode } }) => (
        <Checkbox
          checked={selectedCatalogOptions.some(({ catalogRef: ref }) => ref === catalogRef)}
          className="sales-checkbox"
          onChange={e => {
            dispatch({
              type: SELECTED_CATALOGS_OPTIONS,
              payload: {
                addItem: e.target.checked,
                catalogsData: [{ catalogRef, catalogCurrencyCode }]
              }
            });
          }}
        />
      )
    },
    {
      Header: 'Date',
      accessor: ({ catalogDateFull }) => catalogDateFull,
      id: 'result-date',
      sortable: false
    },
    {
      Header: 'Title',
      id: 'result-title',
      sortable: false,
      minWidth: 290,
      Cell: ({ original: { catalogTitle, catalogRef } }) => (
        <Button
          variant="text"
          color="secondary"
          className="mx-2"
          onClick={() => showResultsHandler(catalogRef)}
        >
          {catalogTitle}
        </Button>
      )
    }
  ];

  return (
    <Grid sx={{ mb: 4 }} style={{ ...style }}>
      <Box sx={{ px: 3 }} className="auction-container">
        <Box>
          <strong>{groupName}</strong>
        </Box>
      </Box>
      <ReactTable
        minRows={0}
        columns={columns}
        showPagination={false}
        pageSize={catalogs.length}
        style={{ width: '100%' }}
        data={catalogs}
        className="-highlight"
      />
    </Grid>
  );
};

export default CatalogsGroups;
